import { useQuery } from '@tanstack/react-query';
import { useTRPC } from './trpc.js';

interface UseMeOptions {
  enabled: boolean;
}

export function useMe({ enabled }: UseMeOptions) {
  const trpc = useTRPC();
  return useQuery({ ...trpc.me.get.queryOptions(), enabled });
}
